import { addCountryCode, bidInterest } from "services";
import { useAsyncAction } from "./useAsyncAction";

export type PropertyType = "auction_property" | "private_property";

export type AuctionPropertyRequestType =
  | "view_auction_property_authorised_officer_details"
  | "view_auction_property_authorised_officer_details_with_send_details_to_whatsapp"
  | "auction_property_authorised_officer_contact_details_requested"
  | "send_auction_property_authorised_officer_details_to_whatsapp"
  | "view_auction_property_document"
  | "download_all_auction_property_documents"
  | "download_auction_property_document"
  | "send_all_auction_property_documents_to_user_whatsapp_mobile"
  | "send_single_auction_property_document_to_user_whatsapp_mobile";

export type PrivatePropertyRequestType =
  | "view_private_property_seller_details"
  | "view_private_property_seller_details_with_send_details_to_whatsapp"
  | "private_property_seller_contact_details_requested"
  | "send_private_property_seller_details_to_whatsapp"
  | "view_private_property_document"
  | "download_all_private_property_documents"
  | "download_private_property_document"
  | "send_all_private_property_documents_to_user_whatsapp_mobile"
  | "send_single_private_property_document_to_user_whatsapp_mobile";

export type BidInterestRequestType =
  | AuctionPropertyRequestType
  | PrivatePropertyRequestType
  | "auction_property_images_requested"
  | "private_property_images_requested"
  | "na";

interface BidInterestApiPayloadType {
  requestType: BidInterestRequestType;
  propertyType: PropertyType;
  propertyListingId: string;
  remark?: string | null;
  userMobile: string;
  userEmail?: string | null;
  userName?: string | null;
}

export function useBidInterestApi() {
  return useAsyncAction(
    async ({
      propertyType,
      requestType,
      propertyListingId,
      remark,
      userMobile,
      userEmail,
      userName,
    }: BidInterestApiPayloadType) => {
      if (!propertyListingId || !requestType) {
        throw new Error("Missing required bid interest fields");
      }

      const apiPayload = {
        property_id: propertyListingId || "",
        ...(userEmail?.trim()?.toLowerCase() && {
          email: userEmail?.trim()?.toLowerCase(),
        }),
        ...(userName && { name: userName }),
        mobile_number: userMobile ? addCountryCode(userMobile) : "NA",
        ...(requestType && { request_type: requestType }),
        property_type: propertyType,
        ...{
          remark: remark,
        },
      };

      await bidInterest(apiPayload);
      return true;
    },
  );
}
